module.exports = __webpack_public_path__ + "img/hero-site.2a55f98e.webp";